const doc = [({"en":({"js":({"admin":({"products":({"select":({"select_product":"Select product"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;